var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 21.74L43.42 10.64C42.3144 9.00404 40.4745 8.01682 38.5 8H10.5C8.51511 7.99913 6.65821 8.97999 5.54004 10.62L24.5 21.74Z",
    fill: "#6B7CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 25.18C25.8923 25.5325 25.2025 25.7188 24.5 25.72C23.7993 25.7249 23.1096 25.5456 22.5 25.2L4.5 14.66V34C4.5 37.3137 7.18629 40 10.5 40H38.5C41.8137 40 44.5 37.3137 44.5 34V14.66L26.5 25.18Z",
    fill: "#6B7CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon3.e39da2d431999d85ad720e9e5c55c166.svg";
export { ForwardRef as ReactComponent };